import { render } from "./WishboardCreate.vue?vue&type=template&id=77e6b12c&scoped=true"
import script from "./WishboardCreate.vue?vue&type=script&lang=js"
export * from "./WishboardCreate.vue?vue&type=script&lang=js"

import "./WishboardCreate.vue?vue&type=style&index=0&id=77e6b12c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e6b12c"]])

export default __exports__